'use client';

import { freddyTheme, GridItem, IconButton } from '@coolblue-development/freddy';
import { PauseInvertedCircled, PlayInvertedCircled } from '@coolblue-development/icons';
import React, { useState } from 'react';

import {
  CONTROL_BUTTONS_POSITION_FOR_MOBILE,
  CONTROL_BUTTONS_SIZE_FOR_DESKTOP,
  CONTROL_BUTTONS_SIZE_FOR_MOBILE,
  VIDEO_CARD_MOBILE_HEIGHT
} from './';

export const ControlButtons = () => {
  const [isPlaying, setIsPlaying] = useState(true);

  const pausePlayVideo = () => {
    const iframe = document.querySelector('iframe');
    if (!iframe?.contentWindow) return;
    const func = isPlaying ? 'pauseVideo' : 'playVideo';

    // Post message to the YouTube iframe to pause the video
    iframe.contentWindow.postMessage(`{"event":"command","func":"${func}","args":""}`, '*');

    setIsPlaying(!isPlaying);
  };

  return (
    <GridItem
      column='12 / 12'
      alignSelf='end'
      sx={{
        position: 'absolute',
        top: `calc(${VIDEO_CARD_MOBILE_HEIGHT} - (${CONTROL_BUTTONS_POSITION_FOR_MOBILE} + ${CONTROL_BUTTONS_SIZE_FOR_MOBILE}))`,
        right: `${CONTROL_BUTTONS_POSITION_FOR_MOBILE}`,
        [freddyTheme.breakpoint.minWidth('lg')]: {
          top: 'auto',
          bottom: '2.4rem'
        }
      }}
    >
      <IconButton
        variant='solid'
        shape='round'
        aria-label={isPlaying ? 'Pause' : 'Play'}
        onClick={pausePlayVideo}
        sx={{
          height: CONTROL_BUTTONS_SIZE_FOR_MOBILE,
          width: CONTROL_BUTTONS_SIZE_FOR_MOBILE,
          padding: 0,
          svg: {
            height: 'inherit',
            width: 'inherit'
          },
          [freddyTheme.breakpoint.minWidth('lg')]: {
            width: CONTROL_BUTTONS_SIZE_FOR_DESKTOP,
            height: CONTROL_BUTTONS_SIZE_FOR_DESKTOP
          }
        }}
      >
        {isPlaying ? <PauseInvertedCircled /> : <PlayInvertedCircled />}
      </IconButton>
    </GridItem>
  );
};
